import styled from 'styled-components';

export const StyledSvg = styled.svg`
    width: 100%;
    height: auto;
`;
